<script setup lang="ts">
import { inject, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const { t } = useI18n()
const isReadOnly = inject('isReadOnly')
const specResponse = inject('specResponse')
const route = useRoute()

const detailText = ref<string>(t('zoppm.step0.readonlyExplanation'))

const getDetailText = () => {
  if (Object.keys(route.query).length !== 0) {
    if (route.query.subjekt === 'FO') {
      specResponse?.zoppmSpec?.sekcie?.find((sekcia: any) => {
        if (sekcia.sekciaRef?.nazov === 'zoppm.ss.vzor-ziadost-fo') {
          detailText.value = sekcia.instrukcie
            ? sekcia.instrukcie
            : t('zoppm.step0.readonlyExplanation')
        }
      })
    }
    if (route.query.subjekt === 'PO') {
      specResponse?.zoppmSpec?.sekcie?.find((sekcia: any) => {
        if (sekcia.sekciaRef?.nazov === 'zoppm.ss.vzor-ziadost-po') {
          detailText.value = sekcia.instrukcie
            ? sekcia.instrukcie
            : t('zoppm.step0.readonlyExplanation')
        }
      })
    }
  }
}
onMounted(() => {
  getDetailText()
})
</script>

<template>
  <IDSKRow>
    <IDSKCol variant-desktop="two-thirds">
      <IDSKHeading as="h1" variant="xl" class="mb-8">
        {{ t('zoppm.step0.mainHeading') }}
      </IDSKHeading>
      <IDSKParagraph v-if="isReadOnly" variant="large" class="mb-8" v-html="detailText">
      </IDSKParagraph>
      <IDSKHeading as="h2" variant="l" class="mb-7">{{
        t('zoppm.step0.subHeading')
      }}</IDSKHeading>
    </IDSKCol>
  </IDSKRow>
</template>

<style lang="scss"></style>
